<!-- desktop -->
<div class="w-screen h-[100dvh] overflow-hidden">
      <ng-container *ngIf="navigatorVal()">
            <mat-drawer-container class="relative z-0 flex justify-center items-center overflow-hidden" autosize>
                  <iho-loading *ngIf="!datasource" class="absolute top-1/2 left-0 w-full h-screen !z-[99999]" />
                  <div id="map-content"></div>
                  <div *ngIf="datasource"
                        class="absolute top-5 cursor-pointer w-[110px] flex justify-between !z-[9999] back-btn-desk"
                        (click)="backHistory()">
                        <i class="ico-Close"></i>
                        <span class="text-sm font-bold">بستن نقشه</span>
                  </div>
                  <iho-map-hotel-searchbox *ngIf="datasource && csrStatus()" [dataSource]="datasource"
                        (onSelectItem)="searchBoxSelectItem($event)"
                        class="absolute top-5 right-0 w-[400px] px-10 !z-[99999]" />
                  <mat-drawer #drawer class="p-5 w-[380px]  relative !z-[99999]" mode="side"
                        [opened]="showHotelListDrawer">
                        <div *ngIf="datasource;else cardLoading" id="main-card-list"
                              class="w-full h-full !z-[99999] relative flex flex-col mt-5 p-3">
                              <div class="w-full">
                                    <h1 class="text-lg font-bold">{{infoPage.Title}}</h1>
                                    <p class="text-sm">{{infoPage.CountHotel}} واحد اقامتی</p>
                              </div>
                              <ng-container *ngFor="let hoteldata of datasource; let index = index;">
                                  
                                    <div id="card-{{hoteldata.CardData.Id != -1 ? hoteldata.CardData.Id : hoteldata.CardData.HouseId }}"
                                          class="cursor-pointer" #card>

                                          <iho-map-hotel-card [urlSearch]="searchResultUiService.searchResult().Search"
                                                (click)="syncHotellistWithMarker(hoteldata.CardData)" [id]="index"
                                                [dataSource]="hoteldata" />

                                    </div>
                              </ng-container>
                        </div>
                  </mat-drawer>
                  <div (click)="showHotelListDrawer = !showHotelListDrawer"
                        class="cursor-pointer absolute -right-1 top-1/2 w-10 !z-[99999] h-16 bg-white p-3 rounded-md flex justify-center items-center">
                        <ng-container *ngIf="showHotelListDrawer">
                              <i class="ico ico-Right text-4xl mr-1"></i>
                        </ng-container>
                        <ng-container *ngIf="!showHotelListDrawer">
                              <i class="ico ico-Left text-4xl mr-1"></i>
                        </ng-container>
                  </div>
            </mat-drawer-container>
            <ng-template #cardLoading>
                  <div class="mt-10">
                        <div class="grid grid-cols-1 gap-4 w-full">
                              <div *ngFor="let item of [].constructor(7)"
                                    class="overflow-hidden w-full rounded-xl card-item-1 shadow-sm border border-solid bg-white">
                                    <div class="w-full object-cover h-44 dark-overlay"></div>

                                    <!-- card's title -->
                                    <div class="flex flex-col gap-3 my-3 px-3">
                                          <div class="flex flex-col gap-1">
                                                <iho-skeleton height="1.25rem" width="10rem" />

                                                <div class="flex items-center gap-2">
                                                      <iho-skeleton height="1rem" width="1rem" />
                                                      <iho-skeleton height="1rem" width="6rem" />
                                                </div>
                                                <iho-skeleton height="1rem" width="5rem" />
                                          </div>

                                          <!-- card's optional part -->

                                          <div class="flex flex-col gap-1">


                                                <div class="flex w-100 items-center gap-2">
                                                      <iho-skeleton height="2rem" width="2rem" />

                                                      <div class="flex flex-col gap-1">
                                                            <iho-skeleton height="1rem" width="5rem" />
                                                            <iho-skeleton height="1rem" width="7rem" />
                                                      </div>
                                                </div>
                                          </div>


                                          <!-- card's footer -->
                                          <div class="flex flex-col gap-2 items-end w-full">
                                                <div class="flex w-full items-center gap-1 justify-end">
                                                      <iho-skeleton height="1rem" width="5rem" />
                                                      <iho-skeleton height="2rem" width="2rem" />
                                                </div>


                                                <iho-skeleton height="1.5rem" width="7rem" />

                                          </div>


                                    </div>
                              </div>
                        </div>
                  </div>
            </ng-template>
      </ng-container>

      <!-- mobile -->
      <ng-container *ngIf="!navigatorVal()">
            <div class="w-full relative lg:hidden">
                  <iho-loading *ngIf="!datasource" class="absolute top-1/2 left-0 w-full h-screen !z-[99999] lg:hidden" />
                  <div id="map-content" class="lg:hidden"></div>
                  <div *ngIf="datasource" class="fixed top-[30px] right-0  !z-[9999] back-btn lg:hidden"
                        (click)="backHistory()">
                        <i class="ico-ArrowRight"></i>
                  </div>
                  <iho-map-hotel-searchbox *ngIf="datasource && csrStatus()" [dataSource]="datasource"
                        (onSelectItem)="searchBoxSelectItem($event)"
                        class="fixed top-[30px] right-[55px] w-[75%]  !z-[9999] lg:hidden" />

                  <div class="w-full fixed bottom-[16px] right-0 z-[99999] h-auto bg-transparent lg:hidden">
                        <div *ngIf="datasource" id="main-card-list">

                              <swiper *ngIf="csrStatus()" [config]="swiperConfigMobile" class="lg:hidden"
                                    #swiperMobile>
                                    <ng-template swiperSlide *ngFor="let hoteldata of datasource; let index = index;">
                                          <div (click)="syncHotellistWithMarker(hoteldata.CardData)">
                                                <div id="card-{{hoteldata.CardData.Id != -1 ? hoteldata.CardData.Id : hoteldata.CardData.HouseId }}"
                                                      class="cursor-pointer px-3" #card>
                                                      <iho-map-hotel-card
                                                            [urlSearch]="searchResultUiService.searchResult().Search"
                                                            [id]="index" [dataSource]="hoteldata" />

                                                </div>
                                          </div>

                                    </ng-template>
                              </swiper>




                        </div>

                  </div>
            </div>

      </ng-container>


      <div #mapHotelPopup>
            <iho-map-hotel-popup *ngIf="selectedHotel() && navigatorVal()" [hotelData]="activeHotel()" />
      </div>

</div>